import axios from "axios";
import BaseCamApi from "./BaseCamApi";
import CamBanner from "../CamBanner";

export default class Cam4Api extends BaseCamApi {
    constructor(config) {
        super('Cam4', config);

        this.siteId = config.cam4.siteId;
        this.apiUrl = config.cam4.apiUrl;
        this.baseUrl = new URL(config.cam4.baseUrl);
        this.zoneMap = config.cam4.zoneMap;
    }

    /**
     * @returns {boolean}
     */
    get isActive() {
        return super.isActive && this.siteId;
    }

    /**
     * @param {string} gender
     * @returns {Promise<object[]>}
     */
    async loadRawBanners(gender) {
        const url = new URL(this.apiUrl);
        url.searchParams.append('sid', this.siteId);
        url.searchParams.append('gender', gender);

        try {
            const response = await axios.get(url.toString());
            return Array.isArray(response.data) ? response.data : [];
        } catch (err) {
            console.error(err);
            return [];
        }
    }

    /**
     * @param {object} rawBanner
     * @returns {CamBanner}
     */
    makeCamBanner(rawBanner) {
        return new CamBanner(
            rawBanner.nickname,
            rawBanner.nickname,
            `${rawBanner.age}, ${rawBanner.sex_preference}`,
            rawBanner.thumb,
            zone => {
                const params = this.baseUrl.searchParams;
                if (this.autoLoginData) {
                    params.set('aff_unique1', this.autoLoginData.username);
                    params.set('aff_unique2', this.autoLoginData.accessHash);
                }

                params.set('aff_unique3', rawBanner.nickname);

                if (zone) {
                    params.set('aff_sub', this.zoneMap[zone] || zone);
                }

                return this.baseUrl.toString();
            }
        );
    }
};
